/**
 * Export APIs sometimes return JSON errors with HTTP 200 and responseType blob.
 * Detect that so we don't save JSON as .xlsx/.csv.
 */
export const resolveExportBlob = async (blob, { expectXlsx = false } = {}) => {
  if (!blob) {
    return { ok: false, message: "Export failed" }
  }
  if (!(blob instanceof Blob)) {
    return { ok: true, data: blob }
  }

  const buffer = await blob.arrayBuffer()
  const bytes = new Uint8Array(buffer)

  // JSON payloads start with '{'
  if (bytes.length && bytes[0] === 0x7b) {
    try {
      const json = JSON.parse(new TextDecoder().decode(bytes))
      return {
        ok: false,
        message: json.msg || json.message || "Export failed",
      }
    } catch (error) {
      return { ok: false, message: "Export failed" }
    }
  }

  // Valid xlsx is a ZIP (PK..)
  if (expectXlsx && (bytes[0] !== 0x50 || bytes[1] !== 0x4b)) {
    return { ok: false, message: "Export failed" }
  }

  return {
    ok: true,
    data: new Blob([buffer], {
      type:
        blob.type ||
        (expectXlsx
          ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          : "text/csv"),
    }),
  }
}
